import { FC } from 'react';

import { Separator } from '@smartshell/ui-kit';
import cn from 'classnames';

import { IRevenueTooltipProps } from './interfaces';
import s from './Revenue.module.scss';

export const RevenueTooltip: FC<IRevenueTooltipProps> = ({
  title,
  text_1,
  text_2,
  footer,
  value_1,
  value_2,
  variant,
  mod,
}) => {
  return (
    <div className={s.tooltip_content}>
      <span className={cn(s.title, mod && s[mod])}>{title}</span>
      {variant === 'primary' && (
        <>
          <div className={s.info}>
            <div className={s.line}>
              <span className={cn(s.text, s.text_bold)}>{text_1}</span>
              <span className={cn(s.value, s.value_bold)}>{value_1}</span>
            </div>
            {value_2 && (
              <div className={s.line}>
                <span className={s.text}>{text_2}</span>
                <span className={s.percent}>{value_2}</span>
              </div>
            )}
          </div>
          {footer && <Separator />}
        </>
      )}
      {footer && <span className={s.footer}>{footer}</span>}
    </div>
  );
};
